import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import {
    SpsPageTitleComponent,
    SpsPageSubtitleComponent,
} from "../components/index";


@NgModule({
    imports: [CommonModule],
    exports: [SpsPageTitleComponent, SpsPageSubtitleComponent],
    declarations: [SpsPageTitleComponent, SpsPageSubtitleComponent],
    providers: []
})
export class SpsPageTitleModule {}
